// Create a context for the global banner which will be used to display a message in the bottom of the page and the message will be displayed in a slim banner and will be able to edit / disable the message exposing the state of the message in the context
import { createContext, type ReactNode, type FC, useState } from 'react'

type GlobalBannerContextProps = {
  globalBannerMessage: string
  setGlobalBannerMessage: (message: string) => void
}

export const GlobalBannerContext = createContext<GlobalBannerContextProps | undefined>(undefined)

export const GlobalBannerProvider:FC<{ children: ReactNode }> = ({ children }) => {
	const [globalBannerMessage, setGlobalBannerMessage] = useState<string>('')
  return <GlobalBannerContext.Provider value={{ globalBannerMessage, setGlobalBannerMessage }}>{children}</GlobalBannerContext.Provider>
}